<template>
  <div>
    <el-input type="text" readonly v-model="myValue" :placeholder="placeholder">
      <el-button v-if="accept == 'image'" @click="dialog.show = true" size="mini" slot="append" type="primary"
        icon="el-icon-camera"></el-button>
      <el-button v-if="accept == 'video'" @click="dialog.show = true" size="mini" slot="append" type="primary"
        icon="el-icon-video-camera"></el-button>
    </el-input>

    <el-dialog fullscreen @opened="openCamera" @close="stopCamera" :width=dialog.width :visible.sync="dialog.show"
      :close-on-click-modal="false" :show-close="false">
      <div class="center">
        <div v-show="cameraState" class="container center">
          <div class="center">
            <div>相机</div>
            <div v-show="isRecording">({{ header }}录制中)</div>
          </div>
          <video ref="videoCamera" :style="containerStyle" style="margin-top:10px;"></video>
        </div>
        <div v-show="!cameraState" class="container center">
          <div>{{ header }}</div>
          <el-image v-if="accept == 'image'" class="border" :style="containerStyle" :src="url">
          </el-image>
          <video
            v-if="accept == 'video' && ((myValue === '' || cameraOpen) && (url && srcUrl) || !(myValue === '' || cameraOpen))"
            class="border" controls autoplay>
            <source :src="url" type="video/webm">
            您的浏览器不支持播放
          </video>
        </div>
      </div>
      <div slot="title" class="dialog-footer">
        <div style="display: flex;align-items: center;justify-content: space-between;">
          <h3>{{ header }}</h3>
          <div style="display: flex;justify-content: center;">
            <div v-if="accept == 'image'">
              <el-button type="primary" @click="restart" :disabled="disabled">重 拍</el-button>
              <el-button type="primary" @click="takePhoto" :disabled="disabled">拍 照</el-button>
              <el-button type="success" @click="upload" :disabled="disabled">上 传</el-button>
              <el-button @click="stopCamera">关 闭</el-button>
            </div>
            <div v-if="accept == 'video'">
              <el-button type="primary" @click="restart" :disabled="disabled">重 拍</el-button>
              <el-button type="primary" @click="startRecording" :disabled="disabled">开 始</el-button>
              <el-button type="primary" @click="stopRecording" :disabled="!isRecording || disabled">停 止</el-button>
              <!-- <el-button type="primary" @click="saveRecording" :disabled="!recordedBlobs.length || disabled">下 载</el-button> -->
              <el-button type="success" @click="upload" :disabled="disabled">上 传</el-button>
              <el-button @click="stopCamera">关 闭</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    attribute: {
      type: Object,
      default: () => ({
        videoWidth: 640,
        videoHeight: 480,
        audio: false,
      })
    },
    accept: {
      type: String,
      default: "image"
    },
    header: {
      type: String,
      default: "照片"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "点击拍摄照片"
    },
  },
  data() {
    return {
      isRecording: false,
      mediaRecorder: null,
      recordedBlobs: [],

      camera: {},
      myValue: this.value,
      srcUrl: "",
      srcUrlShow: false,
      cameraOpen: this.myValue == '',
      dialog: { show: false, width: "1024px" },
    };
  },
  computed: {
    containerStyle() {
      return { width: this.attribute.videoWidth + 'px', height: this.attribute.videoHeight + 'px' }
    },
    cameraState() {
      return (this.myValue == '' || this.cameraOpen) && !this.srcUrlShow
    },
    url() {
      if (!(this.myValue == '' || this.cameraOpen)) return this.$axios.defaults.baseURL + this.myValue;
      else if (this.srcUrlShow) return this.srcUrl;
      else return "";
    }
  },

  mounted() {
  },

  watch: {
    value(newValue) {
      this.myValue = newValue
    },
    myValue(newValue) {
      this.$emit('input', newValue)
    }
  },

  methods: {
    async openCamera() {
      if (!this.cameraState) return;
      this.camera.container = this.$refs.videoCamera;
      this.camera.photoCanvas = document.createElement("canvas");
      this.camera.photoCanvas.width = this.attribute.videoWidth;
      this.camera.photoCanvas.height = this.attribute.videoHeight;
      this.camera.photoContext = this.camera.photoCanvas.getContext("2d");
      try {
        const constraints = { audio: this.attribute.audio || false, video: { width: this.attribute.videoWidth, height: this.attribute.videoHeight } }
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        this.camera.container.srcObject = stream;
        this.camera.container.play();
        if (this.accept == 'video') {
          this.mediaRecorder = new MediaRecorder(stream);
          this.mediaRecorder.ondataavailable = this.handleDataAvailable;
        }
      } catch (error) {
        let message = error.message || error,
          response = {
            'permission denied': '浏览器禁止本页面使用摄像头，请开启相关的权限',
            'requested device not found': '未检测到摄像头',
            'could not start video source': '无法访问到摄像头，请重新插拔后重试'
          };
        this.$message({ message: response[message.toLowerCase()] || '请确认摄像头能正常工作，必须使用谷歌浏览器或者360浏览器的极速模式，否则拍照不能正常使用', type: 'warning' });
        // 无法使用摄像头，不安全网站提示处理方法：
        // 1.在地址栏输入chrome://flags/#unsafely-treat-insecure-origin-as-secure
        // 2.在“Insecure origins treated as secure”中填入地址端口号(http://47.93.121.213:5007)并选择启用后点击重新加载
      }
    },
    handleDataAvailable(event) {
      if (event.data && event.data.size > 0) {
        this.recordedBlobs.push(event.data);
      }
    },
    takePhoto() {
      if (!this.cameraState) {
        this.$message.error("请点击重拍，打开相机")
        return;
      }
      this.camera.photoContext.drawImage(this.camera.container, 0, 0, this.attribute.videoWidth, this.attribute.videoHeight);
      this.srcUrl = this.camera.photoCanvas.toDataURL('image/png');
      this.srcUrlShow = true;
    },
    restart() {
      this.srcUrlShow = false;
      this.srcUrl = "";
      if (!this.cameraOpen) {
        this.cameraOpen = true
        this.$nextTick(() => this.openCamera())
      }
    },
    startRecording() {
      if (!this.cameraState) {
        this.$message.error("请点击重拍，打开相机")
        return;
      }
      this.recordedBlobs = [];
      this.mediaRecorder.start();
      this.isRecording = true;
      this.mediaRecorder.onstop = () => {
        const blob = new Blob(this.recordedBlobs, { type: 'video/webm' });
        this.srcUrl = URL.createObjectURL(blob); // 将 Blob 数据转换为 URL
      };
    },
    stopRecording() {
      this.mediaRecorder.stop();
      this.isRecording = false;
      this.srcUrlShow = true
    },
    async saveRecording() {
      const blob = new Blob(this.recordedBlobs, { type: 'video/webm' });
      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(blob);
      const res = await this.$axios.get('/Api/GetId');
      const id = res.data.data;
      downloadLink.download = id + '.webm'; // 设置下载文件名
      downloadLink.textContent = '点击这里下载录制的视频'; // 设置链接文本
      document.body.appendChild(downloadLink);
      downloadLink.click();
    },
    async upload() {
      if (this.srcUrl == null || this.srcUrl == "") {
        if (this.cameraOpen) {
          this.myValue = '';
          this.$message({ message: "清空成功" });
        }
        else this.$message({ message: "未进行拍摄", type: "error" });
        return;
      }
      const formData = new FormData();
      if (this.accept == "video") {
        const blob = new Blob(this.recordedBlobs, { type: 'video/webm' });
        formData.append('file', blob, 'video.webm'); // 'video.webm' 是文件名
      }
      if (this.accept == "image") {
        const blob = await (await fetch(this.srcUrl)).blob();
        formData.append('file', blob, 'photo.png');  // 'file' 是后端期望的字段，'photo.png' 是文件名
      }
      this.$axios.post("/Api/Upload", formData).then((res) => {
        if (res.data.code === 200) {
          this.myValue = res.data.data;//url
          this.$message({ message: "上传成功", type: "success" });
        } else this.$message({ message: res.data.msg, type: "warn" });
      });
    },
    stopCamera() {
      this.srcUrlShow = false;
      this.cameraOpen = false;
      this.srcUrl = "";
      this.recordedBlobs = [];
      if (this.camera.container != null && this.camera.container.srcObject) {
        const stream = this.camera.container.srcObject;
        stream.getTracks().forEach(track => track.stop());
        this.camera.container.srcObject = null;
      }
      this.dialog.show = false;
    },
  }
}
</script>
<style>
.container {
  border: 1px solid blanchedalmond;
  flex-direction: column;
  padding: 10px;
  margin: 10px;
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.border {
  margin-top: 10px;
  border: 1px solid rebeccapurple;
}
</style>